import React, {useState, useEffect} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../modal";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { ToastContainer, toast } from "react-toastify";
import ModalPop from 'components/sales/modal/modal';
import Images from "assets/images/imageData";

const Valet = ({
                   valetList,
                   createValet,
                   valetRes,
                   documentUploadUrlPublic,
                   documentUrlDataPublic
}) => {

    const [count, setCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [employee, setEmployee] = useState('');
    const [notify, setNotify] = useState("");
    const [firstNameValidation, setFirstNameValidation] = useState("")
    const [lastNameValidation, setLastNameValidation] = useState("")
    const [projectIdValidation, setProjectIdValidation] = useState("")
    const [phoneNoValidation, setPhoneNoValidation] = useState("")
    const [aadharCardValidation, setAadharCardValidation] = useState("")
    const [drivingLicenceValidation, setDrivingLicenceValidation] = useState("")
    const [panCardValidation, setPanCardValidation] = useState("")
    const [profileValidation, setProfileValidation] = useState("")
    const [typeValidation, setTypeValidation] = useState("")
    const [inputList, setInputList] = useState([
        {
            first_name: '',
            last_name: '',
            project_id: '',
            phone_no: '',
            adhar_card: '',
            driving_licence: '',
            pan_card: '',
            type: '',
            profile: ''
        }
    ]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fusionRole, setFusionRole] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState('');

    const saveImage = (val, index = null) => {
        if (index != null) {
            const list = [...inputList];
            list[0]["profile"] = val;
            setInputList(list);
        }
    };

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        if(key=='phone_no'){
            setPhoneNumber(val)
        }
        list[0][key] = val;
        setInputList([...list]);
    
    };
    const approveRequest = (val) => {
        setIsModalOpen(false)
        setIsLoading(false)
        // const list = [...inputList];
        // list[0][key] = val;
        // setInputList([...list]);
    };
    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]

        setFirstNameValidation("")
        setLastNameValidation("")
        setProjectIdValidation("")
        setPhoneNoValidation("")
        setPanCardValidation("")
        setAadharCardValidation("")
        setProfileValidation("")
        setDrivingLicenceValidation("")
        setTypeValidation("")
        if(inputValues.last_name != "") {
            var text = inputValues.last_name;
            if(text.includes("valet") || text.includes("Valet")) {
               toast.error('Please remove valet keyword from last name.');
               return false;
            }
        }

        if(inputValues.first_name === ""){
            setFirstNameValidation("First name is required")
        }
        // else if(inputValues.last_name === ""){
        //     setLastNameValidation("Last name is required")
        // }
        else if(inputValues.project_id === ""){
            setProjectIdValidation("Project id is required")
        }
        else if(inputValues.phone_no === "" || inputValues.phone_no.length > 10 || inputValues.phone_no.length < 10){
            setPhoneNoValidation("Phone Number is required and must be 10 digit")
        }
        // else if(inputValues.pan_card === ""){
        //     setPanCardValidation("Pan card is required")
        // }else if(inputValues.driving_licence === ""){
        //     setDrivingLicenceValidation("Driving licence is required")
        // }else if(inputValues.adhar_card === ""){
        //     setAadharCardValidation("Adhaar card is required")
        // }else if(employee === ""){
        //     setTypeValidation("Type is required")
        // }else if(inputValues.profile === ""){
        //     setProfileValidation("Profile is required")
        // }

        if (inputValues.first_name !== '' &&
            inputValues.project_id !== '' &&
            inputValues.phone_no !== '' && inputValues.phone_no.length === 10
        ) {
            inputValues.type = employee
            setIsLoading(true)
            let res = await createValet(inputValues)
            setNotify(res.data.response.status)
            setIsLoading(false)
            setCount(count+1)
        }
    }

    useEffect(() => {
        const role = localStorage.getItem('fusion-role');
        setFusionRole(role);
      }, []);


    return (
        <>

            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        {valetRes !== null && notify !== 200 &&
                            <CustomModal msg={valetRes.response.message} click={count}/>}
                        {valetRes !== null && notify === 200 &&
                            <CustomModal msg={valetRes.response.message} isPageLoad={true}  click={count}/>}
                        <div className="card-header">
                            {localization.valet}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="validation">{phoneNoValidation}</div>
                                    <ConstantInput
                                        label={localization.phoneNumber}
                                        type="number"
                                        value={phoneNumber}
                                        handleChange={(val) => {
                                            if(parseInt(val.length)===10){
                                                (async()=> {
                                                    setIsLoading(true)
                                                    const res = await valetList({phone_number:val});
                                                    if(res){
                                                        if(parseInt(res?.count)==0){
                                                            setIsModalOpen(true)
                                                        }
                                                    }
                                                    setIsLoading(false)
                                                })();
                                            }
                                            handleInputValue(val, 'phone_no', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{projectIdValidation}</div>
                                    <ConstantInput
                                        label={localization.projectId}
                                        type="number"
                                        value={inputList.project_id}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'project_id', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{firstNameValidation}</div>
                                    <ConstantInput
                                        label={localization.firstName}
                                        type="text"
                                        value={inputList.first_name}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'first_name', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{lastNameValidation}</div>
                                    <ConstantInput
                                        label={localization.lastName}
                                        type="text"
                                        value={inputList.last_name}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'last_name', 0);
                                        }}
                                        //required
                                        //isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{panCardValidation}</div>
                                    <ConstantInput
                                        label={localization.panNumber}
                                        type="text"
                                        value={inputList.pan_card}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'pan_card', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{aadharCardValidation}</div>
                                    <ConstantInput
                                        label={localization.aadharCard}
                                        type="text"
                                        value={inputList.adhar_card}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'adhar_card', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{drivingLicenceValidation}</div>
                                    <ConstantInput
                                        label={localization.drivingLicence}
                                        type="text"
                                        value={inputList.driving_licence}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'driving_licence', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{typeValidation}</div>
                                    <select className="browser-default custom-select custom-select-lg mb-5"
                                            onChange={(event) => setEmployee(event.target.value)}
                                            value={employee}
                                            required>
                                        <option value="0" defaultValue>Types</option>
                                        <option value="employee">Employee</option>
                                        <option value="contractor">Contractor</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <div className="validation">{profileValidation}</div>
                                    <FileUpload
                                     id="profile"
                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) =>
                                        saveImage(val, 'profile')
                                    }

                                >
                                                        <span className="btn btn-transparent">
                                                            {localization.profile}
                                                        </span>
                                </FileUpload>
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalPop
                        title={'Manage Stage'}
                        show={isModalOpen}
                        handleModalHide={() => {
                            handleInputValue('', 'phone_no', 0);
                            setIsModalOpen(false)
                            }
                        }
                    >
                        <div className="row text-center">
                            <div className="col-12">
                                <img src={Images?.ErrorImg} alt="" style={{width:"10%"}} />
                            </div>
                            <div className="col-12">
                                <h5>This driver doesn't exists, Please contact central ops.</h5>
                            </div>
                            {fusionRole != 76 && (
                            <div className="col-12">
                                <button className="btn btn-success border-success" onClick={() => approveRequest(true)}>
                                    Approve
                                </button>
                            </div>
                            )}
                            
                            </div>
                        
                    </ModalPop>
                </div>
            </Layout>
        </>
    );
};
export default Valet
